import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import { useDrawer } from 'ducks/drawers/hooks'
import selectCurrentUser from 'ducks/currentUser/selectors/selectCurrentUser'
import StartContent from 'components/StartContent'
import inbox from 'assets/inbox_empty.png'
import { CHANNEL_EMAIL_TYPES } from 'subapps/settings/components/drawers/Channels/Channels.data'
import { googleLogo as GoogleLogo } from 'assets/icons/groove'
import { buildDrawerQueryParam } from 'ducks/drawers/util'

import { styles } from './styles'

const EmptyPage = () => {
  const currentUser = useSelector(selectCurrentUser)

  const { openDrawer: openEmailDrawer } = useDrawer(
    CHANNEL_EMAIL_TYPES.forwarding.drawer
  )
  const { drawerId, openDrawer: openOAuthDrawer } = useDrawer(
    CHANNEL_EMAIL_TYPES.google.drawer
  )

  const handleCreateEmail = useCallback(
    () => {
      openEmailDrawer('new', {
        additionalProps: {
          firstStep: true,
          drawerSource: 'inbox',
        },
      })
    },
    [openEmailDrawer]
  )

  const handleCreateOAuth = useCallback(
    () => {
      openOAuthDrawer('new', {
        query: {
          ...buildDrawerQueryParam(drawerId, 'drawerChannelType', 'google'),
        },
        additionalProps: {
          firstStep: true,
          drawerSource: 'inbox',
        },
      })
    },
    [openOAuthDrawer, drawerId]
  )

  const firstName = currentUser?.first_name

  return (
    <div css={styles.container}>
      <div css={styles.innerContainer}>
        <StartContent
          title={firstName ? `Welcome ${firstName}!` : 'Welcome!'}
          subtitle={`Let's get your emails flowing in by connecting your first ${app.t(
            'mailbox'
          )} to your Groove account.`}
          css={styles.content}
        >
          <div css={[text.styles.textSm, text.styles.fontSemibold]}>
            Setup time of 2 minutes or less
          </div>
          <div css={styles.btns}>
            <Button
              css={[styles.btn, styles.oAuthButtton]}
              type="info"
              size="xBig"
              onClick={handleCreateOAuth}
              customIcon={<GoogleLogo />}
            >
              Connect Gmail
            </Button>
            <Button
              type="tertiary"
              size="xBig"
              css={[styles.btn, styles.emailBtn]}
              onClick={handleCreateEmail}
            >
              Add email from another provider
            </Button>
          </div>
        </StartContent>
        <div css={styles.imgWrapper}>
          <img src={inbox} alt="Empty" />
        </div>
      </div>
    </div>
  )
}

export default EmptyPage
